export default __webpack_public_path__ + "static/media/configure_zoom_to_record.db880378.png";